import { render, staticRenderFns } from "./license-card-single.vue?vue&type=template&id=57b37931&"
import script from "./license-card-single.vue?vue&type=script&lang=js&"
export * from "./license-card-single.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports